import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useAuth } from '../../commons/Auth';
import { useTranslation } from 'react-i18next';
import { useLoading } from '../../commons/Loading';
import { useAlert } from 'react-alert';
import { NumberParam, useQueryParams, withDefault } from 'use-query-params';
import InteractionsPresentational from './InteractionsPresentational';

const { REACT_APP_DEFAULT_PAGINATION_LIMIT = 50 } = process.env;

const Interactions = ({ profile }) => {
  const [{ newToken, newIsAdmin } = {}] = useAuth();
  const [t] = useTranslation();
  const { showLoading, hideLoading } = useLoading();
  const alert = useAlert();

  const [interactions, setInteractions] = useState([]);
  const [total, setTotal] = useState(0);

  const [query, setQuery] = useQueryParams({
    limit: withDefault(NumberParam, +REACT_APP_DEFAULT_PAGINATION_LIMIT),
    offset: NumberParam,
  });

  const { limit, offset } = query;

  const fetchInteractions = async () => {
    showLoading();

    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/marketing/interactions`,
      {
        headers: { Authorization: newToken },
        params: {
          limit,
          offset,
        },
      }
    );

    hideLoading();

    if (response instanceof Error) {
      return alert.error(t('COMMON:GENERIC_ERROR'));
    }

    const { data = [], headers = {} } = response;
    setInteractions(data.interactions || []);
    setTotal(+headers['x-total-count']);
  };

  function onFilter(queryDiff) {
    if (queryDiff.limit && queryDiff.limit !== limit) {
      queryDiff.offset = 0; // return to first page
    }

    setQuery(queryDiff);
  }

  useEffect(() => {
    fetchInteractions();
  }, [limit, offset]);

  return (
    <InteractionsPresentational
      data={interactions}
      profile={profile}
      query={query}
      total={total}
      onFilter={onFilter}
    />
  );
};

export default Interactions;
